import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useCallback } from 'react';
import environment from 'environment';
import * as S from './LogicFlowWebIframe.styles';
import { processLogicFlowWebEvent } from './LogicFlowWebEventProcessor/LogicFlowWebEventProcessor';
import { encodeMacroWizardTagPath } from './encodeMacroWizardTagPath';
import { restartDecisionFlowRequested } from 'actions/searchActions';
import { getRestartDecisionFlowData } from 'extractFromState';
import AuthService from 'services/authService';

const LogicFlowWebIframe = ({ macroWizardTagPath, conversationId }) => {
  const dispatch = useDispatch();
  const restartDecisionFlowData = useSelector(getRestartDecisionFlowData);
  const shouldRestart =
    restartDecisionFlowData.currentConversationId === conversationId &&
    restartDecisionFlowData.tagPath === macroWizardTagPath;

  const interactingSimplrExpertId = AuthService.current().simplrExpert.id;
  const params = {
    macroWizardTagPath: encodeMacroWizardTagPath(macroWizardTagPath),
    shouldRestart,
    useFlowTag: true,
    interactingSimplrExpertId,
  };
  const paramString = new URLSearchParams(params).toString();
  const iframeUrl = `${environment.services.logicFlowWebUrl}/conversation/${conversationId}?${paramString}`;
  const iframeOrigin = new URL(environment.services.logicFlowWebUrl).origin;

  const processEventAction = useCallback(
    (event) => {
      if (event.origin !== iframeOrigin) {
        return;
      }

      const { type, message } = event.data;

      if (!type) {
        return;
      }

      processLogicFlowWebEvent(dispatch, type, message);
    },
    [dispatch, iframeOrigin]
  );

  useEffect(() => {
    window.addEventListener('message', processEventAction);

    return () => {
      dispatch(restartDecisionFlowRequested({}));
      window.removeEventListener('message', processEventAction);
    };
  }, [dispatch, processEventAction]);

  return <S.Iframe src={iframeUrl} title={'Flow Navigator'} />;
};

export default LogicFlowWebIframe;
